import { Gender } from '../../api/ester-b2b-api/private/users/types'

export enum FormTypes {
  BIRTH_YEAR = 'birthYear',
  GENDER = 'gender',
  ZIP_CODE = 'zipCode',
  IS_MANAGER = 'isManager',
}

export type FormData = {
  [key in FormTypes]: string
} & {
  gender: Gender | ''
}

export type FormError = {
  formType: FormTypes | undefined
  errorMessage: string
}

export type SelectOption = {
  value: string
  label: string
}
